import { render } from "./Comparison.vue?vue&type=template&id=7779212e"
import script from "./Comparison.vue?vue&type=script&lang=js"
export * from "./Comparison.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__